import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { PriceResumoCampo } from '../models/price-resumo-campo.model';
import { PriceEditarAdotado } from '../models/price-editar-adotado.model';

@Injectable({
  providedIn: 'root'
})
export class PriceModelService extends BaseService<PriceResumoCampo> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/priceresumo`, injector);
  }

  getByEstimativaId(estimativaId: number, campo: string): Observable<PriceResumoCampo> {
    return this.http.get<PriceResumoCampo>(`${environment.API_PRICE}/priceresumo/getByEstimativaId/${estimativaId}/${campo}`);
  }

  getByEstimativaIdForOriginal(estimativaId: number): Observable<any> {
    return this.http.get<any>(`${environment.API_PRICE}/justificativa/getByEstimativaId/${estimativaId}`);
  }

  adicionarReceitaAdotado(editarAdotado: PriceEditarAdotado) {
    return this.http.post(`${environment.API_PRICE}/priceresumo`, editarAdotado);
  }

  editarReceitaAdotado(editarAdotado: PriceEditarAdotado) {
    return this.http.put(`${environment.API_PRICE}/priceresumo/1`, editarAdotado);
  }
}
